import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "", ...rest }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

// Editorial section opener: small-caps kicker, oversized serif headline,
// thin magazine rule underneath.
export const SectionHeader = ({ eyebrow, title, note, index }) => (
  <div className="max-w-3xl">
    <Reveal>
      <p className="flex items-center gap-4 font-mono text-[11px] font-bold uppercase tracking-[0.25em] text-vermilion sm:text-xs">
        {index ? <span className="text-sand">{String(index).padStart(2, "0")}</span> : null}
        <span className="h-px w-10 bg-vermilion/60" aria-hidden="true" />
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-5 font-display text-[clamp(2rem,3.4vw+0.75rem,3.5rem)] font-medium leading-[1.06] tracking-[-0.015em] text-bone">
        {title}
      </h2>
    </Reveal>
    {note ? (
      <Reveal delay={0.14}>
        <p className="mt-5 text-[15px] leading-relaxed text-sand sm:text-base">{note}</p>
      </Reveal>
    ) : null}
  </div>
);

export const Chip = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center border border-hairline bg-surface px-2.5 py-1 font-mono text-[11px] font-medium text-sand ${className}`}
  >
    {children}
  </span>
);
